




































































































































































































































import dayjs from 'dayjs';
import { computed, defineComponent, getCurrentInstance, reactive, watch, ref } from '@vue/composition-api';
import { ChevronRightIcon, DeleteIcon, CheckIcon, CloseIcon, AddIcon } from 'tdesign-icons-vue';

import SelectAnySpaceTargetFolder from '@/renderer/components/dialog/SelectAnySpaceTargetFolder/index.vue';
import AddMembers, { SubmitEvent } from '@/renderer/components/dialog/AddTransfer/AddMember/index.vue';

import i18n, { i18n_t } from '@/locales/i18n';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
import ipc from '@/renderer/scripts/utils/ipc';
import { RULE_LIST_MAP, RULE_LIST_VALUE_MAP } from '@/renderer/scripts/utils/ConstantConfig/ConstantI18NConfig';
import { overCurrentTime } from '@/renderer/scripts/utils/dayjsUsage';
import fileCollectFormDialogHandler, { IFormData, initFormData } from '../composition/fileCollectFormDialogHandler';

type FileItemData = SMH.SpaceFileItemData;
const disableDate = {
  before: dayjs().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss'),
  after: dayjs().add(50, 'year').format('YYYY-MM-DD HH:mm:ss'),
};
export default defineComponent({
  name: 'FileCollectFormDialog',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'create',
    },
    collectId: {
      type: Number,
      default: -1,
    },
    folderInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    SelectAnySpaceTargetFolder,
    ChevronRightIcon,
    DeleteIcon,
    AddMembers,
    AddIcon,
    CheckIcon,
    CloseIcon,
  },
  setup(props, ctx) {
    const {
      formRules,
      formatOptions,
      namingRulesOptions,
      editOrCreateNamed,
      newNamedOption,
      dialogVisible,
      methods: { onAddNamedOption, onConfirmNamedOption, onCancelNamedOption, toggleDialogVisible, initOtherData },
    } = fileCollectFormDialogHandler();
    const vm = getCurrentInstance()?.proxy || ctx.root;
    const formData: IFormData = reactive(initFormData());
    const headerTitle = ref('');
    const loading = ref(false);
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        ctx.emit('update:show', val);
      },
    });
    watch(
      () => props.show,
      val => {
        if (val) {
          methods.initData();
        }
      },
    );
    watch(
      () => formData.validity,
      val => {
        if (val === 0) {
          formData.expireTime = dayjs().add(7, 'day').add(1, 'minute').format('YYYY-MM-DD HH:mm:ss');
        }
      },
    );
    const methods = {
      initData() {
        if (props.collectId !== -1) {
          headerTitle.value = i18n_t('文件收集设置');
          methods.getLaunchedFileCollectionSetting();
        } else {
          // 初始化数据
          headerTitle.value = i18n_t('发起文件收集');
          if (Object.keys(props.folderInfo).length > 0) {
            Object.assign(formData, {
              ...initFormData(),
              ...props.folderInfo,
              path: props.folderInfo.path.join('/'),
            });
          } else {
            initOtherData();
            Object.assign(formData, initFormData());
          }
        }
      },
      vaildParams() {
        const { title, joinType, allowedUsers = [], path, namingRules = [] } = formData;
        if (title.trim().length === 0) {
          tips.error(i18n_t('标题不能为空'));
          return false;
        }
        if (title.length > 30) {
          tips.error(i18n_t('标题字数超过限制'));
          return false;
        }
        if (path.length === 0) {
          tips.error(i18n_t('保存文件夹不能为空'));
          return false;
        }
        if (joinType === 1 && allowedUsers.length === 0) {
          tips.error(i18n_t('未添加成员'));
          return false;
        }
        if (formData.validity === 0 && overCurrentTime(new Date(), formData.expireTime)) {
          tips.error(i18n_t('过期时间不能小于当前时间'));
          return false;
        }
        if (namingRules.length === 0) {
          tips.error(i18n_t('命名规则至少添加一个'));
          return false;
        }
        return true;
      },
      getParmas(): SMH.launchedFileCollectionParams {
        const params = {
          ...formData,
          collectId: props.collectId !== -1 ? props.collectId : undefined,
          isPermanent: formData.validity !== 0,
          exampleFiles: formData.exampleFiles.map(item => ({
            ...item,
            path: item.path.join('/'),
          })),
          allowedUsers:
            formData.joinType === 0
              ? []
              : formData.allowedUsers?.map(item => ({
                  userId: item.userId,
                })),
          spaceOrgId: formData.spaceOrgId || vm.$store.getters.orgId,
          expireTime: dayjs(formData.expireTime).format('YYYY-MM-DD HH:mm:ss'),
        };
        ['validity', 'joinType'].forEach(val => Reflect.deleteProperty(params, val));
        return params;
      },
      onSubmit() {
        methods.launchedFileCollection();
      },
      // 发起文件收集
      async launchedFileCollection() {
        if (!this.vaildParams()) return;
        try {
          if (props.collectId !== -1) {
            loading.value = true;
            await smh.userAPI.updateLaunchedFileCollectionSetting(this.getParmas());
            ipc.emit(ipc.RENDERER_EVENTS_MAP.COMMAND_REFRESH);
            loading.value = false;
            tips.success(i18n_t('修改成功'));
            innerShow.value = false;
          } else {
            loading.value = true;
            const { data } = await smh.userAPI.launchedFileCollection(this.getParmas());
            ctx.emit('onSaveFileCollectForm', {
              joinType: formData.joinType,
              code: data.code,
              domains: data.domains,
            });
            loading.value = false;
            innerShow.value = false;
            reporter.report('task_create', {
              task_range: formData.joinType === 1 ? 'inside' : 'anyone',
            });
          }
        } catch (e) {
          loading.value = false;
          tips.error(e as MsgError);
        }
      },
      // 获取文件收集设置
      async getLaunchedFileCollectionSetting() {
        const { data } = await smh.userAPI.getLaunchedFileCollectionSetting({
          collectId: props.collectId,
        });
        data.namingRules = data.namingRules?.map(rule => RULE_LIST_VALUE_MAP[rule] || rule);
        const { namingRules = [], exampleFiles = [] } = data;
        const newFromData = {
          ...data,
          allowedUsers: data.allowedUsers.map(v => ({
            ...v,
            name: v.nickname || '',
          })),
          validity: data.isPermanent ? 1 : 0,
          joinType: (data.allowedUsers as []).length > 0 ? 1 : 0,
          expireTime: dayjs(data.expireTime).format('YYYY-MM-DD HH:mm:ss'),
          exampleFiles: exampleFiles.map(item => ({
            ...item,
            path: item.path.split('/'),
          })),
        };
        this.handleNamingRulesOptions(namingRules.map(rule => RULE_LIST_MAP[rule] || rule));
        Object.assign(formData, newFromData);
      },
      handleNamingRulesOptions(list: string[]) {
        const newList = list.filter(item => !namingRulesOptions.value.map(v => v.label).includes(item));
        namingRulesOptions.value = namingRulesOptions.value.concat(
          newList.map(item => ({
            label: item,
            value: item,
          })),
        );
      },
      async onConfirmDeleteFileCollection() {
        try {
          await smh.userAPI.deleteFileCollection({
            collectId: props.collectId,
          });
          tips.success(i18n_t('删除成功'));
          ipc.emit(ipc.RENDERER_EVENTS_MAP.COMMAND_REFRESH);
          innerShow.value = false;
        } catch (e) {
          tips.error(e as MsgError);
        }
      },
      onConfirmAddMemmbers(res: SubmitEvent) {
        Object.assign(formData, {
          allowedUsers: res.added,
        });
        toggleDialogVisible('showAddMembers', false);
      },
      savePathInfo(fileInfo: { dirPath: string; spaceId: string }) {
        const { dirPath, spaceId } = fileInfo;
        formData.path = dirPath;
        formData.spaceId = spaceId;
        toggleDialogVisible('showAddFolder', false);
      },
      saveFileInfo(list: FileItemData[]) {
        Object.assign(formData, {
          exampleFiles: list,
        });
        toggleDialogVisible('showAddFile', false);
      },
      deleteExampleFilesByPath(item: FileItemData) {
        const { path } = item;
        const { exampleFiles } = formData;
        const index = exampleFiles.findIndex(item => item.path === path);
        exampleFiles.splice(index, 1);
      },
    };
    return {
      ...methods,
      headerTitle,
      innerShow,
      formatOptions,
      namingRulesOptions,
      editOrCreateNamed,
      newNamedOption,
      onAddNamedOption,
      onConfirmNamedOption,
      onCancelNamedOption,
      toggleDialogVisible,
      dialogVisible,
      formData,
      disableDate,
      formRules,
      loading,
    };
  },
});
